import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CircularProgress from '@material-ui/core/CircularProgress';

/**
 * TODO: 디자인 (위치 잡기 & 다른 레이어 위에 올릴 수 있게) 
 */
const styles = theme => ({
    root: {
        // zIndex: '9998',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        justifyContent: 'center',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        opacity: '0.2',
        backgroundColor: '#fafafa',
      },
      progress: {
        position: 'absolute',
        margin: theme.spacing(2), // Material-UI: theme.spacing.unit usage has been deprecated.
        zIndex: 9999,
    },
});

const LoadingIndicator = ({
    classes,
    isLoading,
    withCircle
}) =>
    isLoading ? (
        <div className={classes.root}>
            { withCircle && <CircularProgress
                                className={classes.progress}
                                color="inherit"
                                size={80}
                                thickness={3}
                            />
            }
        </div>
    ) : null;

LoadingIndicator.defaultProps = {
    withCircle: true
}

LoadingIndicator.propTypes = {
    classes: PropTypes.object,
    isLoading: PropTypes.bool,
    withCircle: PropTypes.bool,
};

export default withStyles(styles)(LoadingIndicator); 
